export default {
  digitalOceanSpaces: "https://yinn28.nyc3.digitaloceanspaces.com",
  bucketName: "yinn28",
};
